/* ============== Card Quick Add: talla rápida en tarjeta de producto ============== */
(function () {
  function getCardVariants(card) {
    if (!card) return null;
    var script = card.querySelector('script[data-card-variants]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function detectSelectedVariantInCard(card, variants, colorIndex) {
    if (!card || !variants) return null;

    // 1. Stored from prior click tracking
    var vid = card.getAttribute('data-selected-variant');
    if (vid) return vid;

    // 2. Look for swatches marked as selected/active anywhere in card
    var selectedEl = card.querySelector(
      '.swatch-selected[data-variant-id], .swatch-king-selected[data-variant-id], ' +
      '.is-selected[data-variant-id], [aria-checked="true"][data-variant-id], ' +
      '.active[data-variant-id], .selected[data-variant-id], ' +
      '.swatch-view-item.swatch-selected[data-variant-id]'
    );
    if (selectedEl) return selectedEl.getAttribute('data-variant-id');

    // 3. Check the main product link for ?variant=ID (SK may update href)
    var cardLink = card.querySelector('.grid-product__link');
    if (cardLink && cardLink.href) {
      var m = cardLink.href.match(/[?&]variant=(\d+)/);
      if (m) return m[1];
    }

    // 4. Color value-based detection (SK may use data-value/data-color)
    if (colorIndex >= 0) {
      var colorEl = card.querySelector(
        '.swatch-selected[data-value], .is-selected[data-value], ' +
        '[aria-checked="true"][data-value], .active[data-value], .selected[data-value]'
      );
      if (colorEl) {
        var colorVal = colorEl.getAttribute('data-value');
        if (colorVal) {
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].options[colorIndex] === colorVal) return variants[i].id;
          }
        }
      }
    }

    return null;
  }

  function resolveVariantForSize(card, sizeBtn) {
    var fallbackId = sizeBtn.getAttribute('data-variant-id');
    if (!card) return fallbackId;
    var variants = getCardVariants(card);
    if (!variants) return fallbackId;
    var colorIndex = parseInt(card.getAttribute('data-color-index'), 10);
    var sizeIndex = parseInt(card.getAttribute('data-size-index'), 10);
    if (isNaN(sizeIndex) || sizeIndex < 0) return fallbackId;
    if (isNaN(colorIndex) || colorIndex < 0) return fallbackId;

    var selectedVid = detectSelectedVariantInCard(card, variants, colorIndex);
    if (!selectedVid) return fallbackId;

    var selectedVar = null;
    var fallbackVar = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(selectedVid)) selectedVar = variants[i];
      if (String(variants[i].id) === String(fallbackId)) fallbackVar = variants[i];
    }
    if (!selectedVar || !fallbackVar) return fallbackId;

    var chosenSize = fallbackVar.options[sizeIndex];
    var selectedColor = selectedVar.options[colorIndex];

    var exactMatch = null;
    var anyMatch = null;
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      if (v.options[colorIndex] === selectedColor && v.options[sizeIndex] === chosenSize) {
        if (v.available && !exactMatch) exactMatch = v;
        if (!anyMatch) anyMatch = v;
      }
    }
    var picked = exactMatch || anyMatch;
    return picked ? picked.id : fallbackId;
  }

  // Track Swatch King swatch interactions inside each card
  function trackSwatchClick(e) {
    var t = e.target;
    if (t.closest('[data-card-add-trigger], [data-card-add-size], [data-card-add-panel], [data-card-add-close]')) return;
    var card = t.closest('.grid-product');
    if (!card) return;

    var node = t.closest('[data-variant-id]');
    if (node && card.contains(node)) {
      var vid = node.getAttribute('data-variant-id');
      if (vid) { card.setAttribute('data-selected-variant', vid); return; }
    }
    // Also catch elements with data-value (color name) e.g. SK uses data-value on swatches
    var valNode = t.closest('[data-value]');
    if (valNode && card.contains(valNode)) {
      var colorIndex = parseInt(card.getAttribute('data-color-index'), 10);
      if (!isNaN(colorIndex) && colorIndex >= 0) {
        var variants = getCardVariants(card);
        if (variants) {
          var colorVal = valNode.getAttribute('data-value');
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].options[colorIndex] === colorVal) {
              card.setAttribute('data-selected-variant', variants[i].id);
              return;
            }
          }
        }
      }
    }
  }
  document.addEventListener('click', trackSwatchClick, true);
  document.addEventListener('mouseover', trackSwatchClick, true);
  document.addEventListener('touchstart', trackSwatchClick, { capture: true, passive: true });

  function getPanelByProductId(productId) {
    return document.querySelector('[data-card-add-panel][data-product-id="' + productId + '"]');
  }
  function getTriggerByProductId(productId) {
    return document.querySelector('[data-card-add-trigger][data-product-id="' + productId + '"]');
  }

  function closeAllPanels(exceptId) {
    document.querySelectorAll('[data-card-add-panel]').forEach(function (panel) {
      var pid = panel.getAttribute('data-product-id');
      if (pid === exceptId) return;
      if (!panel.hasAttribute('hidden')) panel.setAttribute('hidden', '');
      var trigger = getTriggerByProductId(pid);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openPanel(productId) {
    closeAllPanels(productId);
    var panel = getPanelByProductId(productId);
    var trigger = getTriggerByProductId(productId);
    if (panel) panel.removeAttribute('hidden');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closePanel(productId) {
    var panel = getPanelByProductId(productId);
    var trigger = getTriggerByProductId(productId);
    if (panel) panel.setAttribute('hidden', '');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function addVariantToCart(variantId, sizeEl, productId) {
    if (!variantId) return;
    sizeEl.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        sizeEl.classList.remove('is-loading');
        if (!res.ok) {
          sizeEl.classList.add('is-disabled');
          return;
        }
        sizeEl.classList.add('is-added');
        setTimeout(function () { sizeEl.classList.remove('is-added'); }, 1200);
        closePanel(productId);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: res.data, addToCartBtn: sizeEl }
        }));
      })
      .catch(function () {
        sizeEl.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-card-add-panel]')) {
      e.preventDefault();
      e.stopPropagation();
    }

    var trigger = e.target.closest('[data-card-add-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var pid = trigger.getAttribute('data-product-id');
      var panel = getPanelByProductId(pid);
      if (panel && panel.hasAttribute('hidden')) {
        openPanel(pid);
      } else {
        closePanel(pid);
      }
      return;
    }

    var closeBtn = e.target.closest('[data-card-add-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var panelClose = closeBtn.closest('[data-card-add-panel]');
      if (panelClose) closePanel(panelClose.getAttribute('data-product-id'));
      return;
    }

    var sizeBtn = e.target.closest('[data-card-add-size]');
    if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (sizeBtn.classList.contains('is-disabled') || sizeBtn.classList.contains('is-loading')) return;
      var panelSize = sizeBtn.closest('[data-card-add-panel]');
      var sizePid = panelSize ? panelSize.getAttribute('data-product-id') : null;
      var card = sizePid ? document.querySelector('.grid-product[data-product-id="' + sizePid + '"]') : null;
      var variantId = resolveVariantForSize(card, sizeBtn);
      addVariantToCart(variantId, sizeBtn, sizePid);
      return;
    }

    if (!e.target.closest('[data-card-add-panel]') && !e.target.closest('[data-card-add-trigger]')) {
      closeAllPanels(null);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    var target = e.target;
    if (e.key === 'Escape') { closeAllPanels(null); return; }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (target.matches('[data-card-add-trigger], [data-card-add-close], [data-card-add-size]')) {
      e.preventDefault();
      target.click();
    }
  });
})();

/* ============== Limitar swatches de color (Swatch King) en tarjetas ==============
   Cuando un producto tiene más de 6 colores, muestra solo 6 y añade un "+N"
   enlazado al producto, para que no se desborden sobre el icono del carrito. */
(function () {
  var MAX = 5;

  function processList(parent) {
    if (!parent) return;
    var items = [];
    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList && children[i].classList.contains('swatch-view-item')) {
        items.push(children[i]);
      }
    }
    var total = items.length;
    var existing = parent.querySelector(':scope > .sk-more-colors');

    if (total <= MAX) {
      if (existing) existing.parentNode.removeChild(existing);
      for (var j = 0; j < items.length; j++) items[j].classList.remove('sk-hidden-swatch');
      return;
    }

    var remaining = total - MAX;

    // Idempotencia: si ya está bien aplicado, no tocar el DOM (evita bucles)
    var alreadyOk = existing
      && existing.getAttribute('data-count') === String(remaining)
      && items[MAX].classList.contains('sk-hidden-swatch')
      && !items[MAX - 1].classList.contains('sk-hidden-swatch');
    if (alreadyOk) return;

    for (var k = 0; k < total; k++) {
      if (k < MAX) items[k].classList.remove('sk-hidden-swatch');
      else items[k].classList.add('sk-hidden-swatch');
    }
    if (existing) existing.parentNode.removeChild(existing);

    var more = document.createElement('a');
    more.className = 'sk-more-colors';
    more.setAttribute('data-count', String(remaining));
    more.textContent = '+' + remaining;
    var card = parent.closest('.grid-product');
    var link = card && card.querySelector('.grid-product__link');
    more.setAttribute('href', link ? link.getAttribute('href') : '#');
    if (card) more.setAttribute('aria-label', '+' + remaining);
    items[MAX - 1].insertAdjacentElement('afterend', more);
  }

  function run() {
    var items = document.querySelectorAll('.grid-product .swatch-view-item');
    if (!items.length) return;
    var parents = [];
    for (var i = 0; i < items.length; i++) {
      var p = items[i].parentElement;
      if (p && parents.indexOf(p) === -1) parents.push(p);
    }
    for (var j = 0; j < parents.length; j++) processList(parents[j]);
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 250); }

  if (document.readyState !== 'loading') schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  // Swatch King inyecta los swatches de forma asíncrona
  [400, 900, 1800, 3000].forEach(function (ms) { setTimeout(run, ms); });

  function startObserver() {
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type !== 'childList') continue;
        if (!m.addedNodes.length && !m.removedNodes.length) continue;
        // Ignorar nuestras propias inserciones de "+N"
        var onlyOurs = m.addedNodes.length > 0;
        for (var a = 0; a < m.addedNodes.length; a++) {
          var n = m.addedNodes[a];
          if (!(n.nodeType === 1 && n.classList && n.classList.contains('sk-more-colors'))) {
            onlyOurs = false;
            break;
          }
        }
        if (onlyOurs) continue;
        schedule();
        return;
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);
})();
